try {
  const getCookie = (key: string): string | null => {
    const filtered: string[][] =
      document.cookie
        .split(';')
        .map(x => x.split('='))
        .filter(x => x[0].replace(/ /, '') === key);
    return !filtered.length ? null : decodeURIComponent(filtered[0][1]);
  }
  const postEvent = (testPatternId: string, url: string, eventType: string, clickId: string | null) => {
    const requestUrl: URL = new URL(String(process.env.WEB_API_URL_EVENT));
    fetch(requestUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization': `Bearer ${process.env.WEB_API_ANON_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'test_pattern_id': testPatternId,
        'url': url,
        'event_type': eventType,
        'click_id': clickId
      })
    });
  }
  const testId: string | null = getCookie('beastt:test_id');
  if (!testId)
    throw new Error('test_id is undefined');
  const testPatternId: string | null = getCookie('beastt:test_pattern_id');
  if (!testPatternId)
    throw new Error('test_pattern_id is undefined');
  postEvent(
    testPatternId,
    location.href,
    'screen_view',
    null
  );
  const nodeList: NodeListOf<Element> = document.querySelectorAll('[data-beastt-click-id]');
  nodeList.forEach((node: Element) => {
    const clickId: string = node.getAttribute('data-beastt-click-id') || 'undefined';
    node.addEventListener('click', () => {
      postEvent(
        testPatternId,
        location.href,
        'click',
        clickId
      );
    });
  })
} catch (e) {
  console.log(`Beastt: monitor does not work because ${e}`);
  // Do nothing
}
